export class ResendToGovViewModel {
  ResendType: string;
  SentStudyList: SentStudyList[];
}

export class SentStudyList {
  OrderId: number;
  AccessionNo: string;
}
